import DhcpForm from "../DhcpForm";

export const DhcpAdd = (): JSX.Element => {
  return <DhcpForm />;
};

export default DhcpAdd;
